import { NoDataComponent, STATUSPAGE } from '@repo/ui';
import ptBr from 'apexcharts/dist/locales/pt-br.json';
import { PerformanceReportForProfessionalsTopValidatedActivitiesItem } from 'presentation/app/modules/Reports/models/performance-report-for-professionals';
import ApexChart from 'react-apexcharts';
import Skeleton from 'react-loading-skeleton';
import { Card, CardBody, CardHeader } from 'reactstrap';

import { getAbbreviatedProfessionalName } from '../../helpers';

interface IProps {
  loading: STATUSPAGE;
  topValidatedActivities: PerformanceReportForProfessionalsTopValidatedActivitiesItem[];
}

export const ValidatedActivitiesPerProfessionalChart = ({
  loading,
  topValidatedActivities,
}: IProps) => {
  const chartData = topValidatedActivities;

  if (loading === STATUSPAGE.LOADING) {
    return (
      <Card>
        <CardHeader className="border-bottom">
          <h5 className="mb-0 text-body">
            Atividades validadas por profissional
          </h5>
        </CardHeader>
        <CardBody className="mb-1">
          <Skeleton
            baseColor="#e8e8e8c5"
            highlightColor="#bababa96"
            style={{ height: '350px' }}
            count={1}
          />
        </CardBody>
      </Card>
    );
  }

  return (
    <Card className="h-100">
      <CardHeader className="border-bottom">
        <h5 className="mb-0 text-body">
          Atividades validadas por profissional
        </h5>
      </CardHeader>
      <CardBody>
        {chartData.length === 0 ? (
          <div className="justify-content-center align-items-center d-flex h-100">
            <NoDataComponent />
          </div>
        ) : (
          <ApexChart
            type="bar"
            height={320}
            options={{
              chart: {
                locales: [ptBr],
                defaultLocale: 'pt-br',
                toolbar: {
                  show: false,
                },
              },
              colors: ['#22C55E'],
              plotOptions: {
                bar: {
                  borderRadius: 6,
                  columnWidth: '45%',
                },
              },
              dataLabels: {
                enabled: false,
              },
              stroke: {
                show: false,
              },
              xaxis: {
                categories: chartData.map((item) =>
                  getAbbreviatedProfessionalName(item.professional.name || ''),
                ),
              },
              yaxis: {
                title: {
                  text: 'Validadas',
                },
              },
              grid: {
                borderColor: '#eef1f7',
              },
            }}
            series={[
              {
                name: 'Atividades validadas',
                data: chartData.map((item) => item.validatedActivitiesCount),
              },
            ]}
          />
        )}
      </CardBody>
    </Card>
  );
};
